import store from "../app/store";

/**
 * Codifica un archivo a base64.
 * @param {File} file - Archivo a codificar
 * @returns {Promise<string>} Promesa con el contenido en base64
 */
function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(",")[1]);
    reader.onerror = (error) => reject(error);
  });
}

/**
 * Convierte un archivo a base64 y construye el cuerpo para servicios de carga.
 * @param {FormData} formData - FormData con el archivo
 * @param {number} fileType - Tipo de archivo según el sistema
 * @param {Object} data - Datos adicionales (companies, checkReplicateBusinessGroup)
 * @returns {Promise<Object>} Objeto con datos del archivo codificado
 */
export async function convertFileToBase64(formData, fileType, data) {
  const userInfo = store.getState().user.user;
  const base64 = await fileToBase64(formData.get("file"));
  const obj = {
    idFileType: fileType,
    eanProvider: userInfo.company.eanCompany,
    fileName: formData.get("file").name,
    idUser: userInfo.firstName.substring(0, 3) + userInfo.lastName.substring(0, 3),
    emailLoad: userInfo.email,
    userLoad: `${userInfo.firstName} ${userInfo.lastName}`,
    fileUpload: base64,
    country: userInfo.company.country,
    provider: userInfo.company.companyName,
    companies: data.companies,
    checkReplicateBusinessGroup: data.checkReplicateBusinessGroup,
  };
  return obj;
}

/**
 * Convierte el archivo a base64 y lo agrega al objeto data existente.
 * @param {FormData} formData - FormData con el archivo
 * @param {Object} data - Objeto data previamente construido
 * @returns {Promise<Object>} Objeto data con fileUpload en base64
 */
export async function convertFileToBase64Dynamic(formData, data) {
  const base64 = await fileToBase64(formData.get("file"));
  data.fileUpload = base64;
  return data;
}